// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import EventBus from '@/components/shared/eventbus';
require('@/components/shared/utilities/pretty_bytes');
import Vue from 'vue';
import VueResource from 'vue-resource'
import i18n from '@/lang/lang';
import App from './App';
import router from './router';
import store from './store/store';
import VTooltip from 'v-tooltip';
import VueMoment from 'vue-moment'
import VueSweetalert2 from 'vue-sweetalert2';
import VuejsDialog from 'vuejs-dialog';
// import Popover  from 'vue-js-popover'
import { VPopover, VClosePopover } from 'v-tooltip'
import VueApexCharts from 'vue-apexcharts'
import Multiselect from 'vue-multiselect'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)
Vue.use(VueResource)

// Vue.use(Popover);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);
Vue.component('multiselect', Multiselect)
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;
Vue.use(router);
Vue.prototype.$eventBus = EventBus;
Vue.use(VTooltip);
Vue.use(VueMoment);

import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)

Vue.use(VuejsDialog);
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js